import { useTheme } from "@mui/styles";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const EvrbedModal = ({
  open,
  toggleModal,
  styles = {},
  children = null,
  title = "",
}) => {
  const theme = useTheme();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const handleClose = state => {
    toggleModal(state);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby={title}
    >
      <div
        className={" evrbed-help-modal"}
        style={{
          position: "absolute",
          top: isMediumScreen ? "50%" : "0%",
          left: isMediumScreen ? "50%" : "0%",
          transform: isMediumScreen ? "translate(-50%, -50%)" : "",
          borderRadius: "180px 0px",
          boxShadow: "0px 0px 25px #00000029",
          backgroundColor: theme.COLORS.WHITE.backgroundWhite,
          ...styles,
        }}
      >
        {children}
      </div>
    </Modal>
  );
};

export default EvrbedModal;
